Vue.component('ack-response-modal', {
	delimiters: ['${', '}$'], // (i) We set up custom delimiters to avoid conflict with liquid interpolations.
	template: '#ack-response-modal',
	mounted() {},
	props: {
		modalText: Object,
		isLoading: Boolean,
	},
	computed: {},
	data() {},
	methods: {},
	beforeDestroy() {},
	watch: {},
});
